/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisDnD
 * @hideconstructor
 *
 * @classdesc Handles drag and drop of metadata to create a visualization.
 */
define([
	'./api/VisDnDAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./VisDnDProviderSet'
], (
	DnDProviderAPI,
	APIFactory,
	VisDnDProviderSet
) => {


	return class VisDnD {

		constructor({ content, features }) {
			this.content = content;
			this.dashboardAPI = features['API'];
			this.dashboardDnD = features['Dashboard.DashboardDnd'];
			this.visualization = features['Visualization'];
			this.providerSets = {};
		}

		//to fix the problem that constructor won't be invoked when vidDnd feature is loaded
		initialize(){
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [DnDProviderAPI]);
			}
			return this.api;
		}

		destroy () {
			this.dashboardAPI = null;
			this.content  = null;
			this.utils && this.utils.destroy();
			this.utilsApi = null;
			this.api = null;

			Object.keys(this.providerSets).forEach((providerKey) => {
				this.providerSets[providerKey].destroy();
			});
			this.providerSets = null;
		}

		registerProviders(type, providers = [], containedTargetsToIgnore = []) {
			if (type && providers && providers.length) {
				let providerSet = this.providerSets[type];
				if (providerSet) {
					providerSet.addProviders(providers);
				} else {
					this.providerSets[type] = new VisDnDProviderSet({
						dashboardAPI: this.dashboardAPI,
						dashboardDnD: this.dashboardDnD,
						content: this.content,
						targetType: type,
						dndProviderList: providers,
						containedTargetsToIgnore: containedTargetsToIgnore
					});
				}
			}
		}

		accepts (source, target) {
			if (this.providerSets[target.type] && this.providerSets[target.type].accepts) {
				return this.providerSets[target.type].accepts(source, target);
			}
			return false;
		}

		onDrop (source, target) {
			if (this.providerSets[target.type] && this.providerSets[target.type].onDrop) {
				this.providerSets[target.type].onDrop(source, target);
			}
		}
	};
});
